module.exports = __webpack_public_path__ + "liberia.svg?1be687fea9043b4844a528c1551e6f54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/liberia.svg
// module id = 213
// module chunks = 10